import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { useTheme } from "styled-components";
import { getParticlesOptions } from "./constants";

export const LightParticles = () => {
  const palette = useTheme().palette.particles.medium;
  const [ready, setReady] = useState(false);

  useEffect(() => {
    initParticlesEngine(loadSlim).then(() => setReady(true));
  }, []);

  useEffect(() => {
    const handleVisibility = () => {
      const canvas = document.querySelector("#tsparticles > canvas") as HTMLCanvasElement;
      if (canvas) canvas.style.display = document.hidden ? "none" : "block";
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, []);

  const options = useMemo(() => getParticlesOptions(palette), [palette]);

  if (!ready) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: -1,
        pointerEvents: "none",
        overflow: "hidden",
      }}
    >
      <Particles
        id="tsparticles"
        options={options}
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );

};
